/*
 * OZ 2026-10-15: the videos in the Grading guide and What's in the box accordions (snippets/oz-pdp-grading.liquid,
 * oz-pdp-box.liquid, oz-pdp-vclip.liquid), ported from the approved mock docs/mockups/2026-10-15_grading-box-videos.
 * Loaded (defer) by snippets/oz-pdp-accordions.liquid only when one of those accordions is on the page.
 *
 * The page holds no video element: each trigger ([data-oz-clip]) carries its URLs, and a video is made only when
 * it is needed.
 *   Desktop (hover: hover and pointer: fine): hovering a trigger plays its muted 3-second preview over the poster;
 *   a click opens the player (made on first use) already playing, with previous / next through the clips of that
 *   accordion (a clip shared by two rows is one stop), arrow keys, Esc, a focus trap and the page scroll locked;
 *   closing gives focus back to the trigger.
 *   Phones and touch screens: no preview; a tap plays the video full screen at once, with sound
 *   (requestFullscreen, or webkitEnterFullscreen on an iPhone). Leaving full screen pauses it and removes it.
 *   If the browser refuses full screen, the player opens instead.
 * Every play of a clip sends GA4 video_start, video_progress (25, 50, 75) and video_complete through window.ozGa
 * (snippets/oz-ga.liquid), naming the clip (oz_target) and where it sits (oz_placement). Hover previews send nothing.
 */
(function () {
  'use strict';

  if (window.OzPdpVideo) { return; }
  window.OzPdpVideo = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SVG = 'http://www.w3.org/2000/svg';

  function quietPlay(v) {
    var p = v.play();
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function icon(name) {
    var svg = document.createElementNS(SVG, 'svg');
    svg.setAttribute('class', 'oz-ic');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var use = document.createElementNS(SVG, 'use');
    use.setAttribute('href', '#oz-vi-' + name);
    svg.appendChild(use);
    return svg;
  }
  function triggerOf(node) {
    return node && node.closest ? node.closest('[data-oz-clip]') : null;
  }
  // src is the original upload (snippets/oz-pdp-vclip.liquid says why); if it fails, Shopify's own copy plays
  function setSource(v, src, alt) {
    v.onerror = null;
    if (alt && alt !== src) {
      v.onerror = function () {
        v.onerror = null;
        var playing = !v.paused || v.autoplay;
        v.src = alt;
        if (playing || v === vmVideo || v === fsVideo || v.classList.contains('oz-vthumb__pv')) { quietPlay(v); }
      };
    }
    v.src = src;
  }

  /* ---------- GA4 (snippets/oz-ga.liquid): video_start, video_progress 25/50/75, video_complete per clip played ---------- */
  // where the clip sits: the guide, the box, a modal, the Phonecheck card, the review row; apple_hub_ on the collection hub
  function placementOf(trig) {
    var im = trig.closest('.oz-im');
    var set = trig.closest('[data-oz-vset]');
    var name = set ? set.getAttribute('data-oz-vset') : '';
    var where = im ? 'info_modal_' + (im.id || '').replace('oz-im-', '')
      : trig.closest('.oz-pc') ? 'phonecheck'
      : name === 'grading' ? 'grading_guide'
      : name === 'box' ? 'whats_in_box'
      : name === 'reviews' ? 'review_videos'
      : 'other';
    return (trig.closest('.oz-hub') ? 'apple_hub_' : '') + where;
  }
  function track(v, name, extra) {
    var t = v._ozTrack;
    if (!t || typeof window.ozGa !== 'function') { return; }
    var p = {
      video_provider: 'ozmobiles',
      video_title: t.title,
      video_url: t.url,
      video_duration: isFinite(v.duration) ? Math.round(v.duration) : undefined,
      video_current_time: Math.round(v.currentTime || 0),
      oz_target: t.clip,
      oz_placement: t.placement
    };
    for (var k in extra) { p[k] = extra[k]; }
    window.ozGa(name, p);
  }
  // one play of one clip; the desktop player's video is reused, so show() starts a new one for each clip
  function watch(v, item) {
    var url = item.src || '';
    if (url.indexOf('//') === 0) { url = 'https:' + url; }
    v._ozTrack = { clip: item.clip, title: item.title, placement: item.placement, url: url, marks: {} };
    if (v._ozWatched) { return; }
    v._ozWatched = true;
    v.addEventListener('playing', function () {
      var t = v._ozTrack;
      if (t && !t.marks.start) { t.marks.start = 1; track(v, 'video_start'); }
    });
    v.addEventListener('timeupdate', function () {
      var t = v._ozTrack;
      if (!t || !t.marks.start || !(v.duration > 0)) { return; }
      var pct = v.currentTime / v.duration * 100;
      [25, 50, 75].forEach(function (m) {
        if (pct >= m && !t.marks[m]) { t.marks[m] = 1; track(v, 'video_progress', { video_percent: m }); }
      });
    });
    v.addEventListener('ended', function () {
      var t = v._ozTrack;
      if (t && t.marks.start && !t.marks.end) { t.marks.end = 1; track(v, 'video_complete', { video_percent: 100 }); }
    });
  }

  /* ---------- hover preview (desktop): the muted clip plays over the poster, looping ---------- */
  function boxOf(trig) { return trig.classList.contains('oz-vthumb') ? trig : trig.querySelector('.oz-vthumb'); }
  function startPreview(trig) {
    var src = trig.getAttribute('data-oz-pv');
    var box = boxOf(trig);
    if (!src || !box) { return; }
    var v = box.querySelector('.oz-vthumb__pv');
    if (!v) {
      v = document.createElement('video');
      v.className = 'oz-vthumb__pv';
      v.muted = true;
      v.setAttribute('muted', '');
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = 'none';
      v.setAttribute('aria-hidden', 'true');
      setSource(v, src, trig.getAttribute('data-oz-pv-alt'));
      v.addEventListener('playing', function () {
        if (box.getAttribute('data-oz-hover') === '1') { box.classList.add('is-previewing'); }
      });
      box.insertBefore(v, box.querySelector('.oz-vplay'));
    }
    box.setAttribute('data-oz-hover', '1');
    quietPlay(v);
  }
  function stopPreview(trig) {
    var box = boxOf(trig);
    if (!box) { return; }
    var v = box.querySelector('.oz-vthumb__pv');
    box.setAttribute('data-oz-hover', '0');
    box.classList.remove('is-previewing');
    if (!v) { return; }
    v.pause();
    setTimeout(function () {
      if (box.getAttribute('data-oz-hover') !== '1') { try { v.currentTime = 0; } catch (err) {} }
    }, 220);
  }
  function stopPreviewsIn(root) { each(root.querySelectorAll('[data-oz-clip]'), stopPreview); }

  document.addEventListener('pointerover', function (e) {
    var trig = triggerOf(e.target);
    if (!trig || trig.contains(e.relatedTarget)) { return; }
    if (e.pointerType !== 'mouse' || !canHover.matches || reduceMotion.matches) { return; }
    startPreview(trig);
  });
  document.addEventListener('pointerout', function (e) {
    var trig = triggerOf(e.target);
    if (!trig || trig.contains(e.relatedTarget)) { return; }
    stopPreview(trig);
  });

  /* ---------- desktop player (built on first use) ---------- */
  var vm = null;
  var vmVideo, vmClose, vmStage, vmPrev, vmNext, vmTitle, vmCount;
  var list = [];
  var idx = 0;
  var lastFocus = null;

  function navButton(step, label, name) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'oz-vm__nav';
    b.setAttribute('data-step', String(step));
    b.setAttribute('aria-label', label);
    b.appendChild(icon(name));
    b.addEventListener('click', function () { go(step); });
    return b;
  }
  function buildModal() {
    vm = document.createElement('div');
    vm.className = 'oz-vm';
    vm.setAttribute('role', 'dialog');
    vm.setAttribute('aria-modal', 'true');
    vm.setAttribute('aria-label', 'Video player');
    vm.hidden = true;

    vmClose = document.createElement('button');
    vmClose.type = 'button';
    vmClose.className = 'oz-vm__close';
    vmClose.setAttribute('aria-label', 'Close video');
    vmClose.appendChild(icon('close'));
    vmClose.addEventListener('click', closeModal);

    vmStage = document.createElement('div');
    vmStage.className = 'oz-vm__stage';
    vmPrev = navButton(-1, 'Previous video', 'back');
    vmNext = navButton(1, 'Next video', 'fwd');

    var fig = document.createElement('figure');
    fig.className = 'oz-vm__fig';
    vmVideo = document.createElement('video');
    vmVideo.className = 'oz-vm__video';
    vmVideo.controls = true;
    vmVideo.playsInline = true;
    vmVideo.setAttribute('playsinline', '');
    vmVideo.preload = 'none';
    var cap = document.createElement('figcaption');
    cap.className = 'oz-vm__cap';
    vmTitle = document.createElement('b');
    vmCount = document.createElement('span');
    cap.appendChild(vmTitle);
    cap.appendChild(vmCount);
    fig.appendChild(vmVideo);
    fig.appendChild(cap);

    vmStage.appendChild(vmPrev);
    vmStage.appendChild(fig);
    vmStage.appendChild(vmNext);
    vm.appendChild(vmClose);
    vm.appendChild(vmStage);
    vm.addEventListener('click', function (e) { if (e.target === vm || e.target === vmStage) { closeModal(); } });
    document.body.appendChild(vm);
  }

  function clipsIn(set, placement) {
    var seen = {};
    var out = [];
    each(set.querySelectorAll('[data-oz-clip]'), function (t) {
      var c = t.getAttribute('data-oz-clip');
      if (seen[c]) { return; }
      seen[c] = true;
      out.push({
        clip: c,
        src: t.getAttribute('data-oz-src'),
        alt: t.getAttribute('data-oz-src-alt') || '',
        poster: t.getAttribute('data-oz-poster') || '',
        title: t.getAttribute('data-oz-title') || '',
        placement: placement
      });
    });
    return out;
  }
  function lockScroll(on) {
    var root = document.documentElement;
    if (on) {
      var bar = window.innerWidth - root.clientWidth;
      root.classList.add('oz-vm-lock');
      if (bar > 0) { document.body.style.paddingRight = bar + 'px'; }
    } else if (!root.classList.contains('oz-im-lock')) {
      // an info modal (assets/oz-pdp-info.js) under the player keeps the page locked until it closes too
      root.classList.remove('oz-vm-lock');
      document.body.style.paddingRight = '';
    }
  }
  function show(i) {
    idx = i;
    var item = list[i];
    if (item.poster) { vmVideo.poster = item.poster; } else { vmVideo.removeAttribute('poster'); }
    setSource(vmVideo, item.src, item.alt);
    vmVideo.setAttribute('aria-label', item.title);
    vmTitle.textContent = item.title;
    vmCount.textContent = list.length > 1 ? (i + 1) + ' / ' + list.length : '';
    watch(vmVideo, item);
    vmPrev.hidden = vmNext.hidden = list.length < 2;
    vmPrev.disabled = i === 0;
    vmNext.disabled = i === list.length - 1;
    if (document.activeElement && document.activeElement.disabled) { vmClose.focus({ preventScroll: true }); }
    quietPlay(vmVideo);
  }
  function openModal(trig) {
    if (!vm) { buildModal(); }
    var set = trig.closest('[data-oz-vset]') || trig.parentNode;
    list = clipsIn(set, placementOf(trig));
    var at = 0;
    list.forEach(function (item, i) { if (item.clip === trig.getAttribute('data-oz-clip')) { at = i; } });
    lastFocus = trig;
    stopPreviewsIn(document);
    lockScroll(true);
    vm.hidden = false;
    requestAnimationFrame(function () { vm.classList.add('is-open'); });
    show(at);
    vmClose.focus({ preventScroll: true });
  }
  function closeModal() {
    if (!vm || vm.hidden) { return; }
    vmVideo.pause();
    vmVideo.onerror = null;
    vmVideo.removeAttribute('src');
    vmVideo.load();
    vm.classList.remove('is-open');
    vm.hidden = true;
    lockScroll(false);
    if (lastFocus) { lastFocus.focus({ preventScroll: true }); }
  }
  function go(d) {
    var j = idx + d;
    if (j >= 0 && j < list.length) { show(j); }
  }
  document.addEventListener('keydown', function (e) {
    if (!vm || vm.hidden) { return; }
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeModal(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === 'Tab') {
      var f = [vmClose, vmPrev, vmVideo, vmNext].filter(function (el) { return !el.hidden && !el.disabled; });
      var at = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  }, true);

  /* ---------- phone player: full screen at once, with sound; leaving full screen pauses and removes it ---------- */
  var fsVideo = null;
  function endFullscreen() {
    if (!fsVideo) { return; }
    var v = fsVideo;
    fsVideo = null;
    v.pause();
    v.onerror = null;
    v.removeAttribute('src');
    v.load();
    v.remove();
  }
  function onFullscreenChange() {
    var el = document.fullscreenElement || document.webkitFullscreenElement;
    if (fsVideo && el !== fsVideo) { endFullscreen(); }
  }
  document.addEventListener('fullscreenchange', onFullscreenChange);
  document.addEventListener('webkitfullscreenchange', onFullscreenChange);

  function playFullscreen(trig) {
    endFullscreen();
    stopPreviewsIn(document);
    var v = document.createElement('video');
    v.className = 'oz-fsv';
    v.controls = true;
    v.preload = 'auto';
    var poster = trig.getAttribute('data-oz-poster');
    if (poster) { v.poster = poster; }
    fsVideo = v;
    watch(v, {
      clip: trig.getAttribute('data-oz-clip'),
      title: trig.getAttribute('data-oz-title') || '',
      placement: placementOf(trig),
      src: trig.getAttribute('data-oz-src')
    });
    setSource(v, trig.getAttribute('data-oz-src'), trig.getAttribute('data-oz-src-alt'));
    v.setAttribute('aria-label', trig.getAttribute('data-oz-title') || '');
    document.body.appendChild(v);
    function fallback() {
      if (fsVideo === v) { endFullscreen(); }
      openModal(trig);
    }
    var request = v.requestFullscreen || v.webkitRequestFullscreen;
    if (request) {
      var r;
      try { r = request.call(v); } catch (err) { fallback(); return; }
      if (r && typeof r.catch === 'function') { r.catch(fallback); }
      quietPlay(v);
    } else if (v.webkitEnterFullscreen) {
      // iPhone: a video without playsinline goes full screen as soon as it plays; asking directly is the backup
      v.addEventListener('webkitendfullscreen', endFullscreen);
      try { v.webkitEnterFullscreen(); } catch (err) {}
      v.addEventListener('loadedmetadata', function () {
        if (!v.webkitDisplayingFullscreen) { try { v.webkitEnterFullscreen(); } catch (err) {} }
      }, { once: true });
      quietPlay(v);
    } else {
      fallback();
    }
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    // closing an accordion stops any preview inside it
    var toggle = e.target.closest && e.target.closest('.oz-acc-item--video .card__collapsible-button');
    if (toggle) {
      var item = toggle.closest('.oz-acc-item--video');
      setTimeout(function () { if (toggle.getAttribute('aria-expanded') !== 'true') { stopPreviewsIn(item); } }, 0);
      return;
    }
    var trig = triggerOf(e.target);
    if (!trig || !trig.getAttribute('data-oz-src')) { return; }
    e.preventDefault();
    if (canHover.matches) { openModal(trig); } else { playFullscreen(trig); }
  });
  /* ---------- the review row (snippets/oz-pdp-review-videos.liquid): arrows on pointer screens, a page per click ---------- */
  function setUpRails() {
    each(document.querySelectorAll('[data-oz-vrail]'), function (rail) {
      if (rail.dataset.ozVrailOn) { return; }
      rail.dataset.ozVrailOn = '1';
      var box = rail.closest('.oz-vreviews');
      var nav = box && box.querySelector('[data-oz-vrail-nav]');
      if (!nav) { return; }
      var prev = nav.querySelector('[data-oz-vrail-step="-1"]');
      var next = nav.querySelector('[data-oz-vrail-step="1"]');
      function ends() {
        var max = rail.scrollWidth - rail.clientWidth;
        var show = canHover.matches && max > 2 && rail.offsetParent !== null;
        if (nav.hidden === show) { nav.hidden = !show; }
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max - 2;
      }
      function page(d) {
        var card = rail.children[0];
        var stepW = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0) : rail.clientWidth;
        var per = Math.max(1, Math.floor((rail.clientWidth + 1) / stepW));
        rail.scrollBy({ left: d * per * stepW, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      rail.addEventListener('scroll', ends, { passive: true });
      window.addEventListener('resize', ends);
      ends();
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setUpRails); } else { setUpRails(); }
})();
